import {useContext, useEffect, useState} from "react";
import $ from "jquery";
import "../styles/css/login-public.css"
import "../styles/css/admin-style.css"
import {useNavigate} from "react-router-dom";
import eventEmitter from "../shared/eventEmitter";
import {EventEmitterTypes} from "../shared/eventEmitterEnum";
import {AuthenticationHandler} from "../components/auth/AuthenticationHandler";
import notificationService from "../services/NotificationService";
import {useForm} from "react-hook-form";
import {publicCustomerService} from "../services/publicCustomerService";
import {formatCardNumber, formatWebId} from "../shared/sharedFunctions";
import AuthClientStore from "../components/auth/AuthClientStore";

const PublicLoginPage: React.FC = () => {
    const { register, handleSubmit, setValue, getValues } = useForm();
    const auth = useContext(AuthenticationHandler);
    const navigate = useNavigate();
    const [webId, setWebId] = useState('');
    const [showLogin, setShowLogin] = useState(false)
    const onSubmit = async data => {
        if(!webId || webId === ''){
            notificationService.error("WebId is a required field")
            return;
        }
        const success = await auth.customerLoginUsingWebId(webId)
        if (success) {
            publicCustomerService.getCustomerInfo(AuthClientStore.getWebUniqueId()).then(r => {
                if(!r) {
                    navigate('/no-request-ready')
                    return;
                }
                if(!r.jobDateScheduled)
                    navigate('/member/schedule-estimate', { state: { requestData: r } });
                else 
                    navigate('/member/reschedule-estimate', { state: { requestData: r } });
            })
        }
    }
    useEffect(() => {
        document.body.classList.remove('bg-white');
    },[])
    return (
        <div className="login-public-body">
            <div className="">
                <div className="login-container g-0 fullHeight">
                    <div className="row g-0" style={{height: "100vh"}}>
        
                        <div className="col-lg-8 g-0 h-100 overflow-scroll">
                            <div className="overflow-scroll w-100 h-100 fancyMarketing">
        
                                <div className="marketingContent">
                                    <div className="intro">
                                        <p className="blurb">
                                            At Barreca, we bring expert craftsmanship and top-tier equipment to every sealcoating
                                            project. We're here to protect, preserve, and enhance
                                            your pavement.
                                        </p>
                                    </div>
        
                                    <div className="popoutDiv" style={{paddingTop:"5rem"}}>
                                        <div className="login-container ms-0">
                                            <div className="outline-1"></div>
                                            <div className="outline-2"></div>
                                            <div className="overlay">
                                                <h3 className="">
                                                    <span className="lilIcon">
                                                        <i className="fa-solid fa-person-digging"></i>
                                                    </span>
                                                    Blacktop
                                                </h3>
                                                <p className="">
                                                    Get a smooth, durable surface that's built to last. With proper maintenance,
                                                    asphalt surfaces can last up to 15 years!
                                                </p>
                                            </div>
                                        </div>
                                    </div>
        
                                    <div className="popoutDiv" style={{paddingTop:"5rem", display:"flex", justifyContent:"flex-end"}}>
                                        <div className="login-container me-0">
                                            <div className="outline-1"></div>
                                            <div className="outline-2"></div>
                                            <div className="overlay">
                                                <h3 className="">
                                                    <span className="lilIcon">
                                                        <i className="fa-solid fa-helmet-safety"></i>
                                                    </span>
                                                    Sealcoating
                                                </h3>
                                                <p className="">
                                                    Boost curb appeal and protect your pavement with sealcoating. Shield asphalt
                                                    from UV rays, water, and wear to extend its life!
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
        
                            </div>
                        </div>
        
                        <div className="col-lg-4 g-0 h-100 overflow-scroll bg-white interactionSide">
                            <div className="overflow-scroll w-100 h-100">

                                <div className="actionsWrap">
                                    <div className="logoContainer mb-5">
                                        <img src="/logo/logoBigger.svg" alt="Barreca logo" className="logo"/>
                                    </div>

                                    {!showLogin && 
                                        <>
                                            <div className="doSomething mb-4">
                                                <h2>Learn more</h2>
                                                <p>Fill out our form to request a quote.</p>
                                                <button onClick={() => navigate('/request-estimate')} type="button"
                                                        className="btn btn-lg btn-primary hvr-grow shadow">Request a
                                                    Quote
                                                </button>
                                            </div>
        
                                            <div className="doSomething">
                                                <h2>Already a customer?</h2>
                                                <p>Login to your customer portal.</p>
                                                <button type="button" onClick={() => setShowLogin(true)} className="btn btn-lg btn-outline-primary hvr-grow shadow">Login
                                                </button>
                                            </div>
                                        </>
                                    }
                                    {showLogin && 
                                        <div className="wizard-step">
                                            <a href="#" className="step-back">
                                                <p className="text-black opacity-75 mb-5 fw-medium" onClick={() => setShowLogin(false)}><i
                                                    className="fa fa-regular fa-arrow-left"></i> Back</p>
                                            </a>
                                            <h1 className="fw-bold text-center mb-4">Customer Login</h1>
                                            <form onSubmit={handleSubmit(onSubmit)}>
                                                <fieldset className="form-group mb-3">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control form-control-lg" 
                                                               value={webId}
                                                               onChange={(e) => {
                                                                    const raw = e.target.value;
                                                                    const formatted = formatWebId(raw);
                                                                    setWebId(formatted);
                                                                }}
                                                               placeholder="Web ID" required/>
                                                        <label>Web ID</label>
                                                    </div>
                                                </fieldset>
                                            </form>
                                            <button type="button" onClick={onSubmit}
                                                    className="btn btn-lg btn-block btn-primary login-btn w-100 text-white shadow">Login
                                            </button>
                                            {/* <!-- for later: give them a picture of where to find the WebID -->
                                                <!-- <div class="mt-4">
                                                    <a href="#"><small class="text-primary">How do I find my Web ID?</small></a>
                                                </div> -->*/}
                                        </div>
                                    }

                                </div>

                                

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default PublicLoginPage;
